import { QueryClient } from '@tanstack/react-query';
import isEmbedded from '@/utils/is-embedded';

let client: QueryClient | undefined;

export function getQueryClient(opts = {}): QueryClient {
  if (isEmbedded() && window.ReactTeammateApp?.queryClient) {
    return window.ReactTeammateApp.queryClient;
  }

  client ??= new QueryClient(opts);

  return client;
}

export function resetQueryClient(): void {
  if (client) {
    // Destroy all query observers to clear refetchInterval/staleTimeout timers.
    // In browser tests, vitest-browser-react unmounts components in the next
    // beforeEach -- after our afterEach already runs resetQueryClient(). Without
    // this, observers from the previous test remain alive with active timers
    // that can fire requests after MSW handlers are reset.
    for (const query of client.getQueryCache().getAll()) {
      for (const observer of [...query.observers]) {
        observer.destroy();
      }
    }
    void client.cancelQueries();
    client.clear();
    client = undefined;
  }
}
